import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Slider,
  Button,
  Chip,
  Grid,
  Collapse,
  IconButton
} from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import ClearIcon from '@mui/icons-material/Clear'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { useState } from 'react'
import { useFilters } from '../context/FilterContext'

function FilterPanel({ compact = false }) {
  const [expanded, setExpanded] = useState(!compact)
  const {
    equipmentType, setEquipmentType,
    industry, setIndustry,
    state, setState,
    refrigerant, setRefrigerant,
    manufacturer, setManufacturer,
    ageRange, setAgeRange,
    capacityRange, setCapacityRange,
    filterOptions,
    filteredData,
    filteredStats,
    clearFilters,
    activeFilterCount
  } = useFilters()

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent sx={{ pb: expanded ? 2 : '16px !important' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <FilterListIcon color="primary" />
            <Typography variant="subtitle1" fontWeight={600}>
              Filters
            </Typography>
            {activeFilterCount > 0 && (
              <Chip
                label={`${activeFilterCount} active`}
                size="small"
                color="primary"
                onDelete={clearFilters}
              />
            )}
            <Typography variant="body2" color="text.secondary" sx={{ ml: { xs: 0, sm: 2 } }}>
              Showing {filteredData.length} of {filteredStats?.totalStudies || filteredData.length} studies
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {activeFilterCount > 0 && (
              <Button
                size="small"
                startIcon={<ClearIcon />}
                onClick={clearFilters}
              >
                Clear All
              </Button>
            )}
            {compact && (
              <IconButton size="small" onClick={() => setExpanded(!expanded)} aria-label={expanded ? 'Collapse filters' : 'Expand filters'}>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            )}
          </Box>
        </Box>

        <Collapse in={expanded}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {/* Equipment Type */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Equipment</InputLabel>
                <Select
                  value={equipmentType}
                  label="Equipment"
                  onChange={(e) => setEquipmentType(e.target.value)}
                >
                  <MenuItem value="">All Equipment</MenuItem>
                  {filterOptions.equipmentTypes.map(type => (
                    <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Industry */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Industry</InputLabel>
                <Select
                  value={industry}
                  label="Industry"
                  onChange={(e) => setIndustry(e.target.value)}
                >
                  <MenuItem value="">All Industries</MenuItem>
                  {filterOptions.industries.map(ind => (
                    <MenuItem key={ind} value={ind}>
                      {ind.replace(/_/g, ' ')}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Refrigerant */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Refrigerant</InputLabel>
                <Select
                  value={refrigerant}
                  label="Refrigerant"
                  onChange={(e) => setRefrigerant(e.target.value)}
                >
                  <MenuItem value="">All Refrigerants</MenuItem>
                  {filterOptions.refrigerants.map(ref => (
                    <MenuItem key={ref} value={ref}>{ref}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Manufacturer */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Manufacturer</InputLabel>
                <Select
                  value={manufacturer}
                  label="Manufacturer"
                  onChange={(e) => setManufacturer(e.target.value)}
                >
                  <MenuItem value="">All Manufacturers</MenuItem>
                  {filterOptions.manufacturers.map(mfr => (
                    <MenuItem key={mfr} value={mfr}>{mfr}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* State */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>State</InputLabel>
                <Select
                  value={state}
                  label="State"
                  onChange={(e) => setState(e.target.value)}
                >
                  <MenuItem value="">All States</MenuItem>
                  {filterOptions.states.map(st => (
                    <MenuItem key={st} value={st}>{st}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Age Range */}
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="caption" color="text.secondary">
                Equipment Age: {ageRange[0]} - {ageRange[1]} years
              </Typography>
              <Slider
                value={ageRange}
                onChange={(_, value) => setAgeRange(value)}
                min={0}
                max={30}
                size="small"
                valueLabelDisplay="auto"
              />
            </Grid>

            {/* Capacity Range */}
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="caption" color="text.secondary">
                Capacity: {capacityRange[0]} - {capacityRange[1]} tons
              </Typography>
              <Slider
                value={capacityRange}
                onChange={(_, value) => setCapacityRange(value)}
                min={0}
                max={2000}
                step={50}
                size="small"
                valueLabelDisplay="auto"
              />
            </Grid>
          </Grid>
        </Collapse>
      </CardContent>
    </Card>
  )
}

export default FilterPanel
